import { apimCall } from './api';
import { GoFormzServices } from '../AppSettings';
import { appContext } from '../AppContext';
import { reloadProfile } from '../profile/actions';

/**
 * Save an event to GoFormz DB.
 * @param {string} name Name of the event
 * @param {string} data Data associated with the event. Please provide the data as a string; do not pass JSON objects directly
 * @returns {Promise<void>} A promise that resolves when the event is saved successfully, or rejects with an error.
 */
export const saveEventToGoFormz = (name: string, data: string) => {
  return apimCall(GoFormzServices.AccountService, `/accounts/events`, 'POST', {
    name: name,
    data: data
  })
    .catch((err) => {
      console.error('Failed to save GoFormz Analytics event', err);
    })
    .then(() => {
      reloadProfile()(appContext.store.dispatch);
    })
    .catch((err) => {
      console.error('Failed to reload profile', err);
    });
};
